import { Injectable } from '@angular/core';
import * as moment from 'moment';


@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor() { }

  public combinarDataHora(data: string, hora: string): moment.Moment | null {
    if (!data || !hora) return null;

    const dataHoraStr = `${data} ${hora}`;

    return moment.utc(dataHoraStr, 'DD-MM-YYYY HH:mm');
  }
}
